<template>
  <v-app>
    <v-card app tile flat>
      <v-app-bar color="primary" app dark flat>
        <v-app-bar-nav-icon @click="drawer = true"></v-app-bar-nav-icon>
        <v-toolbar-title v-on:click.ctrl="toggleSave">
          UT<strong>OT</strong>
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <v-tooltip v-for="btn in appBtns" :key="btn.name" bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on" v-show="btn.name === 'Save' ? saveEnabled : true" @click="btn.click">
              <v-icon>{{ btn.icon }}</v-icon>
            </v-btn>
          </template>
          <span>{{ btn.name }} </span>
        </v-tooltip>
      </v-app-bar>
    </v-card>

    <v-navigation-drawer app temporary v-model="drawer">
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title">
            Until Then Online Tools
          </v-list-item-title>
          <v-list-item-subtitle>
            <a href="https://polychromagames.com">Polychroma Games</a>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list dense nav>
        <div v-for="(items, group) in menu" :key="group">
          <v-subheader v-if="group" class="text-uppercase">{{ group }}</v-subheader>
          <v-list-item v-for="item in items" :key="item.name" router :to="item.route">
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ item.name }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </div>
      </v-list>
    </v-navigation-drawer>

    <v-content>
      <router-view />
    </v-content>

    <v-dialog
      v-model="Store.busyDialogShown"
      max-width="390"
      persistent
    >
      <v-card>
        <v-layout row class="ma-0 px-6 py-4" align-center>
          <v-progress-circular
            indeterminate
            color="primary"
            size="40"
            class="mr-2"
          ></v-progress-circular>
          <v-card-title>{{ Store.busyDialogTitle }}</v-card-title>
        </v-layout>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="exportDialog.show"
      max-width="300"
      persistent
    >
      <v-card
        color="primary"
        class="px-2 pt-3"
        dark
      >
        <v-card-text>
          {{ exportDialog.text }}
          <v-progress-linear
            :value="exportDialog.progress"
            color="white"
            class="mb-0 mt-2"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import * as firebase from 'firebase/app'
import 'firebase/database'
import 'firebase/storage'
import fbConfig from './firebase-config.json'
import exporter from './exporter'

firebase.initializeApp(fbConfig)

export default {
  name: 'App',
  injectModels: ['Store'],
  data() {
    return {
      drawer: false,
      saveEnabled: false,
      exportDialog: {
        show: false,
        text: 'Loading...',
        progress: 0
      },
      appBtns: [
        { name: 'Export', icon: 'mdi-download', click: this.export },
        { name: 'Save', icon: 'mdi-content-save', click: this.Store.commitStore },
        { name: 'Fetch', icon: 'mdi-sync', click: this.Store.fetchStore },
        //{ name: 'Settings', icon: 'mdi-cog', click: this.openSettings }
      ],
      menu: {
        '': [
          { icon: 'mdi-home', name: 'Home', route: '/' }
        ],
        Facebook: [
          { icon: 'mdi-account', name: 'Profiles', route: '/fb-profiles' },
          { icon: 'mdi-newspaper', name: 'Pages', route: '/fb-pages' },
          { icon: 'mdi-account-group', name: 'Groups', route: '/fb-groups' },
          { icon: 'mdi-incognito', name: 'Randoms', route: '/fb-randoms' },
          { icon: 'mdi-file' , name: 'Posts', route: '/fb-posts' }
        ],
        Web: [
          { icon: 'mdi-web', name: 'Pages', route: '/web-pages' },
        ]
      }
    }
  },
  methods: {
    openSettings() {
      alert('settingbois')
    },
    toggleSave() {
      this.saveEnabled = !this.saveEnabled
      console.log(this.saveEnabled)
    },
    export() {
      this.exportDialog.show = true

      const onProgress = ({ text, progress }) => {
        this.exportDialog.text = text
        this.exportDialog.progress = progress
      }

      exporter(this.Store.saveStore(), onProgress)
        .then(() => {
          this.exportDialog.show = false
        })
        .catch(err => {
          this.exportDialog.show = false
          console.error(err.message, err)
          alert('An error occurred while exporting :(')
        })
    }
  }
};
</script>

<style>
.fb-link {
  text-decoration: none !important;
  font-weight: bold !important;
  color: black !important;
}

.trim-oneline {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

img, [class*=image] {
  image-rendering: crisp-edges;
}
</style>